import { forwardRef, useImperativeHandle } from 'react';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import '../../views/ServiceReport.css';
import '../forms/Button.css';
import { getLocalizedDateTime } from '../../localization/LocalizedString';

const ExportDatapickExcelButton = forwardRef(({ currentLanguage, translate, data }, ref) => {
  const download = async () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Sheet1');

    sheet.columns = [
      { header: translate('service_report.column_task.user'), key: 'userId', width: 20 },
      { header: translate('service_report.column_task.employeeId'), key: 'employeeId', width: 20 },
      { header: translate('service_report.column_task.date'), key: 'date', width: 25 },
      { header: translate('service_report.column_task.customer'), key: 'customerName', width: 25 },
      { header: translate('service_report.column_task.end_customer'), key: 'companyName', width: 25 },
      { header: translate('service_report.column_task.address'), key: 'streetAddress', width: 30 },
      { header: translate('service_report.column_task.city'), key: 'city', width: 20 },
      { header: translate('service_report.column_task.service_site'), key: 'siteId', width: 20 },
      { header: translate('service_report.column_task.productId'), key: 'productId', width: 20 },
      { header: translate('service_report.column_task.productAmount'), key: 'orderAmount', width: 20 },
    ];

    const sorted = [...data].sort((a, b) => new Date(b.date) - new Date(a.date));

    sorted.forEach((task) => {
      sheet.addRow({
        userId: task.userId,
        employeeId: task.employeeId,
        date: getLocalizedDateTime(new Date(task.date), currentLanguage),
        customerName: task.customer?.name ?? '',
        companyName: task.companyName,
        streetAddress: task.streetAddress,
        city: task.city,
        siteId: task.siteId,
        productId: task.productId,
        orderAmount: task.orderAmount,
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `${translate('service_report.search.type_datapick')}.xlsx`);
  };

  useImperativeHandle(ref, () => ({
    download,
  }));

  return null;
});

export default ExportDatapickExcelButton;
